module.exports = __webpack_public_path__ + "img/members.a0ef0b02.png";